import { GlDisclosureDropdown, GlTooltipDirective, GlDisclosureDropdownItem, GlToggle, GlIcon } from '@gitlab/ui';
import { s__ } from '~/locale';
import { InternalEvents } from '~/tracking';
import { WORK_ITEM_LIST_PREFERENCES_METADATA_FIELDS, METADATA_KEYS } from '~/work_items/constants';
import { workItemRoadmapPath, saveHiddenMetadataKeysToLocalStorage, getHiddenMetadataKeysFromLocalStorage } from '~/work_items/utils';
export default {
    name: 'WorkItemMoreActions',
    i18n: {
        displayOptions: s__('WorkItem|Display options'),
        fields: s__('WorkItems|Fields'),
        showClosed: s__('WorkItem|Show closed items')
    },
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlToggle,
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin()
    ],
    inject: {
        getWorkItemTypeConfiguration: {
            default: null
        }
    },
    props: {
        workItemIid: {
            type: String,
            required: true
        },
        fullPath: {
            type: String,
            required: true
        },
        workItemType: {
            type: String,
            required: true
        },
        showClosed: {
            type: Boolean,
            required: false,
            default: true
        },
        showViewRoadmapAction: {
            type: Boolean,
            required: false,
            default: false
        },
        metadataLocalStorageKey: {
            type: String,
            required: true
        },
        defaultHiddenMetadataKeys: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    emits: [
        'toggle-show-closed',
        'update-hidden-metadata-keys'
    ],
    data () {
        return {
            isDropdownVisible: false,
            hiddenMetadataKeys: getHiddenMetadataKeysFromLocalStorage(this.metadataLocalStorageKey, this.defaultHiddenMetadataKeys)
        };
    },
    computed: {
        workItemTypeConfiguration () {
            // Legacy applications may not have access to the metadata provider
            return this.getWorkItemTypeConfiguration ? this.getWorkItemTypeConfiguration(this.workItemType) : {};
        },
        tooltipText () {
            return !this.isDropdownVisible ? this.$options.i18n.displayOptions : '';
        },
        widgetMetadataFields () {
            return WORK_ITEM_LIST_PREFERENCES_METADATA_FIELDS.filter((field)=>![
                    METADATA_KEYS.COMMENTS,
                    METADATA_KEYS.POPULARITY
                ].includes(field.key));
        },
        workItemRoadmapPathHref () {
            return workItemRoadmapPath(this.fullPath, this.workItemIid);
        },
        viewOnARoadmap () {
            return {
                text: s__('WorkItem|View on a roadmap'),
                href: this.workItemRoadmapPathHref,
                extraAttrs: {
                    'data-testid': 'view-roadmap'
                }
            };
        },
        shouldShowViewRoadmapAction () {
            if (this.showViewRoadmapAction) {
                return this.workItemTypeConfiguration?.supportsRoadmapView;
            }
            return false;
        }
    },
    methods: {
        showDropdown () {
            this.isDropdownVisible = true;
        },
        hideDropdown () {
            this.isDropdownVisible = false;
        },
        toggleMetadataDisplaySettings (fieldKey) {
            const isHidden = this.hiddenMetadataKeys.includes(fieldKey);
            if (isHidden) {
                this.hiddenMetadataKeys = this.hiddenMetadataKeys.filter((key)=>key !== fieldKey);
            } else {
                this.hiddenMetadataKeys = [
                    ...this.hiddenMetadataKeys,
                    fieldKey
                ];
            }
            saveHiddenMetadataKeysToLocalStorage(this.metadataLocalStorageKey, this.hiddenMetadataKeys);
            this.$emit('update-hidden-metadata-keys', this.hiddenMetadataKeys);
        }
    }
};
